module.exports = __webpack_public_path__ + "static/media/team3.7fe4d0e0.jpg";